'use client';

import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@/components/link';
import { useWishlistCount } from '@/providers/wishlist';
import { HeartIcon, HeartNoFillIcon } from '@/shared-ui';
import { cn } from '@/lib/utils';
import { USER_ACTION_ITEM_CLASSES } from './item-classes';

/**
 * Wishlist entry point: a heart link, filled when the shopper has saved items. The count comes from the
 * app-level {@link useWishlistCount}, so the fill stays live without a reload. Visibility is the
 * consumer's call via `className` (the header hides it on mobile).
 */
export const WishlistIcon = ({ className }: { className?: string }): ReactElement => {
    const { t } = useTranslation('header');
    const hasItems = useWishlistCount() > 0;

    return (
        <Link to="/wishlist" className={cn(USER_ACTION_ITEM_CLASSES, className)} aria-label={t('userActions.wishlist')}>
            {hasItems ? <HeartIcon className="size-6" fill="currentColor" /> : <HeartNoFillIcon className="size-6" />}
        </Link>
    );
};
